import {
  BookingVehicleInfoCardProps,
  ChosenOptions,
  VehicleSpecsCardProps,
} from "./BookingVehicleInfoCard.props";
import React, { useState } from "react";
import AppButton from "../../UI/AppButtons/AppButton";
import "animate.css";
import { Modal } from "../../UI/AppModal";
import { Map } from "../../UI/AppModal";
import { ImageCarousel } from "../BookingVehicleInfoCard/ImageCarousel";
import { DesktopFooter } from "../BookingVehicleInfoCard/DesktopFooterProps";
import { MobileFooter } from "../BookingVehicleInfoCard/MobileFooterProps";
import TechnicalSheetModalContent from "../BookingVehicleInfoCard/TechnicalSheetModalContent";
import VehicleHeader from "../BookingVehicleInfoCard/VehicleHeader";
import useVehicleInfo from "../BookingVehicleInfoCard/useVehicleInfo";

const getParentOrigin = () => {
  try {
    if (window.location.ancestorOrigins?.length > 0) {
      return window.location.ancestorOrigins[0];
    }
    if (document.referrer) {
      return new URL(document.referrer).origin;
    }
    return "";
  } catch (error) {
    console.error("Error in getParentOrigin:", error);
    return "";
  }
};

const scrollToTop = () => {
  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  window.parent.postMessage({ event_id: "scrollToTop" }, targetOrigin);
};

function BookingVehicleInfoCard({
  status = "Unavailable",
  ...VehicleDetails
}: BookingVehicleInfoCardProps) {
  const {
    vehicleParameters,
    selectedImage,
    handleBackClick,
    handleForwardClick,
    latitude,
    longitude,
    istabletScreen,
    translate,
    totalPricePerDay,
    totalPrice,
    isSmallScreen,
    isIphoneScreen,
    isAndroidScreen,
    isDesktop,
    openModal,
    setOpenModal,
    isModalOpen,
    setIsModalOpen,
    showMap,
    setShowMap,
    showTechnicalSheet,
    setShowTechnicalSheet,
    mapContainerStyle,
    mapOptions,
    appSettings,
    currentIndex,
    setCurrentIndex,
    setSelectedImage,
  } = useVehicleInfo(VehicleDetails);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    scrollToTop();
    window.scrollTo(0, 0);
  };
  const [paymentType] = useState<"PAYNOW" | "PAYLATER" | undefined>();

  const payNowDisAmount =
    (parseFloat(VehicleDetails.priceDetails.payLater.toString()) *
      VehicleDetails.discount) /
    100;

  const [selectedFields] = useState<ChosenOptions>({
    insurance: undefined,
    options: {},
  });

  function BookButton() {
    /* window.scrollTo(0, 0);*/
    return (
      <AppButton
        disabled={status.toLowerCase() === "unavailable"}
        color="primary"
        className={`h-[43px] rounded-md ${
          isIphoneScreen
            ? "w-[85vw] max-w-[370px] ml-3"
            : isAndroidScreen
            ? "w-[85vw] max-w-[350px] ml-3"
            : "w-[165px]"
        }`}
        clickHandler={() => {
          VehicleDetails.moveToPayment({
            isPayLaterFee: false,
            extrasIncluded: false,
            extrasPrice: 0,
            payLaterFeeAmt: "",
            isDiscounted: payNowDisAmount,
            type: paymentType as "PAYNOW" | "PAYLATER",
            price: totalPrice,
            addedExtraOptions: selectedFields.options,
            selectedInsurance: selectedFields.insurance,
          });
        }}
      >
        <p
          style={{
            fontFamily: "MBCorpoSText-Light-Web-Text-Light",
            fontSize: "14px",
          }}
          className={`min-w-24 w-full h-full flex items-center justify-center text-${VehicleDetails.textColor} capitalize`}
        >
          {translate("Select")}
        </p>
      </AppButton>
    );
  }

  const updateModal = (flag: boolean) => {
    setOpenModal(flag);
    scrollToTop();
    window.scrollTo(0, 0);
  };

  const handleMapClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const hideMap = () => {
    setShowMap(false);
    setShowTechnicalSheet(true);
  };

  const hideTechnicalSheet = () => {
    setShowTechnicalSheet(false);
    setShowMap(true);
  };

  const ModalComponent = ({
    isOpen,
    onClose,
  }: {
    isOpen: boolean;
    onClose: () => void;
  }) =>
    isOpen && (
      <div className="modal-overlay" onClick={onClose}>
        <Map
          isOpen={isOpen}
          handleClose={onClose}
          latitude={latitude}
          longitude={longitude}
          vehicleName={VehicleDetails.locationDescriptionName}
          mapContainerStyle={mapContainerStyle}
          mapOptions={mapOptions}
        />
      </div>
    );

  return (
    <section
      className="hover:drop-shadow-lg cursor-pointer relative flex flex-col bg-white box-border font-roboto text-[#004188] z-12"
      style={
        isDesktop
          ? { height: "680px", borderRadius: "6px" }
          : isSmallScreen
          ? { width: "", borderRadius: "6px" }
          : { width: "439px", borderRadius: "6px" }
      }
    >
      <ImageCarousel
        images={VehicleDetails.vehicleImages}
        selectedImage={selectedImage}
        onSelect={setSelectedImage}
        onPrev={handleBackClick}
        onNext={handleForwardClick}
        isDesktop={isDesktop}
      />

      <div
        className={`md:flex flex-wrap ${
          !isSmallScreen ? "h-[263.13px] mt-[40px]" : ""
        }`}
      >
        <div className="md:gap-8 gap-0 w-full">
          <VehicleHeader
            name={VehicleDetails.vehicleName}
            isSmallScreen={isSmallScreen}
            onInfoClick={() => (!isSmallScreen ? updateModal(true) : hideMap())}
          />

          <div
            className={`grid grid-cols-4 md:grid-cols-4 ${
              !isSmallScreen ? "px-2" : ""
            }`}
          >
            {vehicleParameters.slice(0, 4).map((el, index) => (
              <div key={index} className="h-fit w-full text-sm">
                {el ? (
                  <VehicleSpecsCard {...el} />
                ) : (
                  <div className="w-10 h-10" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {!isSmallScreen ? (
        <DesktopFooter
          isDesktop={isDesktop}
          istabletScreen={istabletScreen}
          isSmallScreen={isSmallScreen}
          totalPricePerDay={totalPricePerDay}
          totalPrice={totalPrice}
          VehicleDetails={{
            dealerName: VehicleDetails.dealerName,
            locationDescriptionName: VehicleDetails.locationDescriptionName,
          }}
          translate={translate}
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          ModalComponent={ModalComponent}
          BookButton={BookButton}
        />
      ) : (
        <MobileFooter
          isDesktop={isDesktop}
          istabletScreen={istabletScreen}
          isSmallScreen={isSmallScreen}
          isIphoneScreen={isIphoneScreen}
          totalPrice={totalPrice}
          totalPricePerDay={totalPricePerDay}
          VehicleDetails={{
            dealerName: VehicleDetails.dealerName,
            locationDescriptionName: VehicleDetails.locationDescriptionName,
          }}
          translate={translate}
          showTechnicalSheet={showTechnicalSheet}
          setShowTechnicalSheet={setShowTechnicalSheet}
          showMap={showMap}
          setShowMap={setShowMap}
          vehicleParameters={vehicleParameters}
          handleMapClick={handleMapClick}
          appSettings={appSettings}
          latitude={latitude}
          longitude={longitude}
          mapContainerStyle={mapContainerStyle}
          mapOptions={mapOptions}
          BookButton={BookButton}
          hideTechnicalSheet={hideTechnicalSheet}
        />
      )}

      {openModal && (
        <Modal
          isOpen={true}
          handleClose={() => updateModal(false)}
          crossIcon={VehicleDetails.vehicleImages.length === 1}
        >
          <TechnicalSheetModalContent
            VehicleDetails={VehicleDetails}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            vehicleParameters={vehicleParameters}
          />
        </Modal>
      )}
    </section>
  );
}

function VehicleSpecsCard({ iconUrl, name }: VehicleSpecsCardProps) {
  const isSmallScreen = window.innerWidth <= 768;
  const colonIndex = name.indexOf(":") + 1;
  const displayName = colonIndex !== -1 ? name.slice(colonIndex) : name;
  return (
    <div className="w-full flex flex-col items-center p-4">
      {iconUrl && (
        <img className="h-[22px] w-[32.42px] mb-2" src={iconUrl} alt={name} />
      )}
      <span
        className="font-light text-black text-center"
        style={{
          fontSize: "14px",
          fontFamily: "MBCorpoSText-Regular-Web-new",
        }}
      >
        {!isSmallScreen ? name : displayName}
      </span>
    </div>
  );
}
export { BookingVehicleInfoCard };
